import { strings as stringManager } from '../../Strings';
export const moduleName = 'marketTrendsCard';
stringManager.load(moduleName, {
    cardTitle: 'Market Trends',
    dateRangeBlurb: 'Total change in pay since',
    jobTitleBlurb: 'Based on PayScale job title {0}'
});
const moduleStrings = stringManager[moduleName];
export { moduleStrings as strings };
export default moduleStrings;
